export default __webpack_public_path__ + "static/media/facts_icon_black.4c9038f7.svg";